/* eslint-disable @typescript-eslint/member-ordering */
import { animate, state, style, transition, trigger } from '@angular/animations'
import { Component, Output, EventEmitter, ElementRef, HostBinding, HostListener, ViewChild } from '@angular/core'
import { IPet } from '@app/models/pet'
import { WorkflowStep } from '@app/models/workflow-step'
import { OrchestratorService } from '@app/services/orchestrator.service'
import { StoreService } from '@app/services/store.service'
import { firstValueFrom } from 'rxjs'
import { VetClinicComponent } from './vet-clinic/vet-clinic.component'

@Component({
	selector: 'mv-add-vet',
	templateUrl: './add-vet.component.html',
	styleUrls: ['./add-vet.component.scss'],
	animations: [
		trigger('state', [
			state('open', style({ opacity: '1', pointerEvents: 'all' })),
			state('void, closed', style({ opacity: '0', pointerEvents: 'none' })),
			transition('* => *', animate('155ms ease-in')),
		]),
	],
})
export class AddVetComponent {
	@ViewChild('vetClinicStep') vetClinicStep?: VetClinicComponent
	public workflowStep$ = this.storeService.workflowState$
	public WorkflowStep = WorkflowStep
	private _petId!: string

	@HostBinding('attr.data-emb-element') embAttribute = true
	@HostBinding('@state') state: 'open'|'closed' = 'closed'

	@HostListener('emb_mv_open_add', ['$event'])
	@HostListener('window:emb_mv:global_add_vet', ['$event'])
	handleOpenAdd (ev: CustomEvent): void {
		this.storeService.cleanupFormState()
		this.storeService.updateWorkflowStep(WorkflowStep.VetClinic)
		this.petId = ev.detail
		this._open()
	}

	@Output() emb_mv_close: EventEmitter<void> = new EventEmitter<void>()

	get petId (): string {
		return this._petId
	}
	set petId (value: string) {
		this._petId = value
	}

	constructor (
		public readonly el: ElementRef<HTMLElement>,
		private readonly orchestratorService: OrchestratorService,
		private readonly storeService: StoreService,
	) { }

	public close (shouldUpdate: boolean = true): void {
		this.state = 'closed'
		this.storeService.cleanupFormState()
		this.storeService.updateWorkflowStep(WorkflowStep.VetClinic)
		if (shouldUpdate) {
			const updateEvent: CustomEvent = new CustomEvent('emb_mv:global_update', { bubbles: true })
			this.el.nativeElement.dispatchEvent(updateEvent)
		}
		this.vetClinicStep?.resetForm()
	}

	private _open (petId: string = this.petId): void {
		if (!petId) return
		this.getPetDetails(petId)
			.then(() => {
				this.state = 'open'
			}).catch(err => console.error(err))
	}

	private async getPetDetails (petId: string): Promise<IPet> {
		if (!petId) return Promise.reject('No petId was provided')
		try {
			const pet = await firstValueFrom(this.orchestratorService.getPetDetails(petId)).then(p => p.pet)
			await this.storeService.updateAppState({
				petId,
				petName: pet.petName,
			})

			return pet
		} catch (err) {
			return Promise.reject(err)
		}
	}
}
